import { Box, Grid, GridItem, Text, Toast, VStack } from '@chakra-ui/react';

import { useCartContext } from 'context/CartContext/CartContext';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useQueryClient } from 'react-query';
import { useNavigate, Navigate } from 'react-router-dom';
import { Header } from './Header/Header';
import { ModalOpenQiCardInstructions } from './ModalOpenQiCardInstructions/ModalOpenQiCardInstructions';
import { ModalSmartphoneInstructions } from './ModalSmartphoneInstructions/ModalSmartphoneInstructions';
import { QiCardInstructions } from './QiCardInstructions/QiCardInstructions';
import { SmartphoneInstructions } from './SmartphoneInstructions/SmartphoneInstructions';
import { TicketHolderForm, FormValues } from './TicketHolderForm/TicketHolderForm';
import { TicketSummary } from './TicketSummary/TicketSummary';
import { useCheckoutMutation } from './hooks/useCheckoutMutation';
import { DIALING_CODE_IRAQ } from 'utils/constants';
import { LoaderOverlay } from 'components/LoaderOverlay/LoaderOverlay';
import { useHoldTokenSessionTimerContext } from 'context/HoldTokenSessionTimerContext/HoldTokenSessionTimerContext';
import { ModalReservationExpired } from './ModalReservationExpired/ModalReservationExpired';
import { useIsAuthenticated } from 'react-auth-kit';
import { ModalLogin } from 'components/ModalLogin/ModalLogin';
import { ConcertResponse, MatchResponse } from 'api/responseTypes';
import { ConcertTicketSummary } from './TicketSummary/ConcertTicketSummary';
import 'https://cdn.marmot-cloud.com/npm/hylid-bridge/2.10.0/index.js';
// import { tzAxios } from 'api/axios';
// import { toast } from 'utils/toast';
import { sendRequest } from 'betterStackConsole';
import { sendOrder, sendOrderNumber } from 'api/QiPaymentOrders';
import { toast } from 'utils/toast';

export interface hylideBridgeObject {
  tradePay: (options: {
    paymentUrl: string;
    success: (res: { resultCode: string }) => void;
    fail: (err: any) => void;
  }) => void;
}

export const CheckoutPage = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const isAuthenticated = useIsAuthenticated();

  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  const { tickets, holdToken, eventId } = useCartContext();
  const [totalPrice, setTotalPrice] = useState(0);
  const [isSmartphoneInstructionsModalOpen, setIsSmartphoneInstructionsModalOpen] = useState(false);
  const [isQiCardInstructionsModalOpen, setIsQiCardInstructionsModalOpen] = useState(false);

  const cachedMatchData: MatchResponse | undefined = queryClient.getQueryData(`event-${eventId}`);
  const cachedConcertData: ConcertResponse | undefined = queryClient.getQueryData(
    `concert-${eventId}`,
  );

  const { holdTokenSessionTimer } = useHoldTokenSessionTimerContext();

  const dialingCode = localStorage.getItem('dialingCode') || DIALING_CODE_IRAQ;
  const { mutate, status } = useCheckoutMutation();

  const handleOpenSmartphoneModal = () => setIsSmartphoneInstructionsModalOpen(true);
  const handleOpenQiCardInstructionsModal = () => setIsQiCardInstructionsModalOpen(true);

  const handleCloseModal = () => {
    setIsSmartphoneInstructionsModalOpen(false);
    setIsQiCardInstructionsModalOpen(false);
  };

  const handleCloseAuthModal = () => {
    setIsAuthModalOpen(false);
  };

  // interface successProps {
  //   resultCode: string;
  // }

  // const my: hylideBridgeObject = (window as any).my;

  // const baseApi = import.meta.env.VITE_APP_BASE_API;

  const phoneNumber = window.qi.user?.mobile.token;

  const userToken: any = window.qi.user?.mobile.token;

  useEffect(() => {
    let sum = 0;
    for (const ticket of tickets) {
      sum += ticket.price;
    }
    setTotalPrice(sum);
  }, [tickets, eventId]);

  const onSubmit = async (data: FormValues) => {
    const theHoldedToken = holdToken ? holdToken : 'empty';
    const ticketHoldersData = data.ticketHolders.map((holder, idx) => ({
      sector: tickets[idx].sector,
      price: tickets[idx].price,
      holderPhone:
        dialingCode +
        (holder.phoneNumber.startsWith('0')
          ? holder.phoneNumber.slice(1) // Remove the first character ('0')
          : holder.phoneNumber),
      holderName: holder.name,
      gate: tickets[idx].entrance ? tickets[idx].entrance : 'main',
      categoryKey: tickets[idx].categoryKey,
    }));

    if (!userToken) {
      if (!isAuthenticated()) {
        setIsAuthModalOpen(true);
        return;
      }

      if (data?.ticketHolders && eventId) {
        const formattedDate = {
          eventInfoId: 1,
          eventId: eventId,
          holdToken: theHoldedToken,
          tickets: ticketHoldersData,
        };
        mutate(formattedDate);
      }
    } else if (userToken) {
      try {
        sendRequest(phoneNumber);
        const response = await sendOrder({
          eventInfoId: 1,
          eventId: eventId,
          holdToken: theHoldedToken,
          tickets: ticketHoldersData,
          paymentMethod: 'QI_SERVICES_PAYMENT_GATEWAY',
        });
        sendRequest(response);
        if (response && response.status && response.status >= 400 && response.status < 500) {
          Toast({
            title: 'Error',
            description: response.message,
            status: 'error',
          });
        } else {
          window.qi.purchase(
            {
              price: totalPrice,
              description: '',
              timeToLiveMillis: 60000,
              merchantTransactionID: response.orderNumber as string,
            },
            async (result) => {
              sendRequest(result);
              sendOrderNumber({ order_number: response.orderNumber }).then((res) => {
                sendRequest(res),
                  Toast({
                    status: 'success',
                    description: res,
                  }),
                  toast({
                    status: 'success',
                    description: 'تمت عملية الشراء بنجاح',
                  });
                navigate('/');
              });
            },
          );
        }
      } catch (error) {
        Toast({
          status: 'error',
          description: 'An error occurred while processing your request.',
        });
        sendRequest(error);
      }
    }
    // else if (my.tradePay) {
    //   try {
    //     await tzAxios
    //       .post(`${baseApi}/orders`, {
    //         variantId: 33,
    //         paymentMethod: 'MINI_PROGRAM',
    //       })
    //       .then((res) => {
    //         const paymentUrl = res.data.link;
    //         my.tradePay({
    //           paymentUrl: paymentUrl,
    //           success: (res: successProps) => {
    //             if (res.resultCode === '6001') {
    //               return toast({
    //                 title: 'Payment is canceled',
    //                 description: `resultCode: ${res.resultCode}`,
    //                 status: 'info',
    //               });
    //             } else if (res.resultCode === '6000') {
    //               return toast({
    //                 title: 'Payment is successful',
    //                 description: `resultCode: ${res.resultCode}`,
    //                 status: 'success',
    //               });
    //             } else if (res.resultCode === '4000') {
    //               return toast({
    //                 title: 'Payment is failed',
    //                 description: `resultCode: ${res.resultCode}`,
    //                 status: 'success',
    //               });
    //             }
    //           },
    //           fail: (err: any) => {
    //             toast({
    //               title: 'Payment Failed in mini app',
    //               description: `err in mini app: ${err}`,
    //               status: 'error',
    //             });
    //           },
    //         });
    //       });
    //   } catch (error: any) {
    //     toast({
    //       title: 'Payment Failed in post request, try is failed',
    //       description: ` ${error.message}`,
    //       status: 'error',
    //     });
    //   }
    // }
  };

  if (!cachedMatchData && !cachedConcertData) {
    return <Navigate to='/' replace={true} />;
  }

  return (
    <>
      {(status === 'loading' || status === 'success') && <LoaderOverlay />}
      <Header />
      <Box width='100vw' mx='auto' px={4} mb='40px'>
        <Grid
          mx='auto'
          maxW='1440px'
          templateColumns={{ base: '1fr', md: '1fr 28%' }}
          gap='24px'
          mt={{ base: '-36px', md: '-100px' }}
          pb='40px'
        >
          <GridItem>
            <TicketHolderForm onSubmit={onSubmit} />
            {userToken === undefined && (
              <VStack mt='40px' align='end' spacing='24px'>
                <Text variant='bodyLargestRegular'>
                  <FormattedMessage
                    id='checkout.paymentDetails'
                    defaultMessage={'Payment Details'}
                  />
                </Text>
                <QiCardInstructions onModalOpen={handleOpenQiCardInstructionsModal} />
              </VStack>
            )}
          </GridItem>
          <GridItem>
            {cachedMatchData ? (
              <TicketSummary {...cachedMatchData.match} />
            ) : cachedConcertData ? (
              <ConcertTicketSummary {...cachedConcertData.concert} />
            ) : (
              <div></div>
            )}

            <SmartphoneInstructions onModalOpen={handleOpenSmartphoneModal} />
          </GridItem>
        </Grid>
      </Box>

      <ModalReservationExpired isOpen={holdTokenSessionTimer === 0} />
      <ModalLogin isOpen={isAuthModalOpen} onClose={handleCloseAuthModal} />
      <ModalSmartphoneInstructions
        isOpen={isSmartphoneInstructionsModalOpen}
        onClose={handleCloseModal}
      />
      <ModalOpenQiCardInstructions
        isOpen={isQiCardInstructionsModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
};
